import React, { type ReactNode } from 'react';
import s from '../styles.css';

type Props = {
  children: ReactNode;
};
export const Container = (props: Props) => <section className={s.container}>{props.children}</section>;
Container.displayName = 'Container';
